import * as React from "react";

import {cs}            from "../react/chain-services";
import {TimeoutAction} from "../react/timeout-action";
import {UseState}      from "../react/use-state";

export const CaptureAutofill = ({name, onChange}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}) => <>
        {state.value && TimeoutAction({
            action: () => state.onChange(null),
        })}
        <input {...{
            value: state.value || "",
            onChange: (e) => {
                const v = e.target.value;
                state.onChange(v);
                onChange(v);
            },
            name,
            style: {
                opacity: 0,
                position: "absolute",
                pointerEvents: "none",
            },
        }} />
    </>
);
